import { HashTag } from "./HashTag"
import { callPostHashTags } from "../../api/v1/hashtag/post"
import { HashTagPostInputModel } from "../../api/v1/hashtag/PostInputModel"

export const postHashTag = (name: string): Promise<HashTag> => {
  const model = new HashTagPostInputModel({ name })

  return callPostHashTags(model)
}
